// extracted by mini-css-extract-plugin
export default {"form":"searchField_form__alSHS","movieListTitle":"searchField_movieListTitle__JKtc4","titleRow":"searchField_titleRow__VQdiL"};